import { Injectable } from '@angular/core';
import Clarity from '@microsoft/clarity';
import { environment } from '../../environments/environment';

/**
 * Inicializa o Microsoft Clarity apenas nos ambientes que possuem
 * `clarityId` configurado (produção e piloto).
 */
@Injectable({
  providedIn: 'root'
})
export class ClarityService {

  private _initialized = false;

  initialize(): void {
    // Só prod e pilot definem `clarityId`; o cast evita quebrar o type-check
    // dos demais builds, que substituem o environment sem essa chave.
    const projectId: string = (environment as any).clarityId;
    if (!projectId || this._initialized) {
      return;
    }

    try {
      Clarity.init(projectId);
      Clarity.setTag('env', environment.envName);
      this._initialized = true;
    } catch (error) {
      console.warn('Não foi possível inicializar o Microsoft Clarity', error);
    }
  }
}
